import { useLottie } from 'lottie-react';
import { Lock } from 'lucide-react';
import loading from '../../../assets/animations/loading.json';
import bgGradient from '../../../assets/illustrations/moving-bg-gradient.png';
import { TextLoop } from '../../atoms';

const Animation = () => {
  const style = {
    width: 650, // Numeric values don't need "px" in React styles
    height: 600,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
  const options = {
    animationData: loading,
    loop: true,
    autoplay: true
  };
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { View } = useLottie(options, style);

  return <>{View}</>;
};

export default function LoadingWithTextLoop({
  loopTexts
}: {
  loopTexts: string[];
}) {
  return (
    <div className=' flex bg-[#ffffffbd] dark:bg-[#000000c4] justify-center w-full h-full fixed left-0 top-0 items-center z-[100] animate-fade-in'>
      <div className='text-xs flex items-center justify-center gap-2 border absolute bottom-[10%] backdrop-blur-[13px] shadow-lg shadow-shadow inset-shadow-shadow left-1/2 -translate-x-1/2  p-2 rounded-[11px] border-border'>
        <div className='bg-sidebar bg-opacity-80 border border-border rounded-[11px] p-3'>
          <Lock className='w-3 h-3 dark:text-white text-black' />
        </div>
        Secure data processing
      </div>
      <div className='absolute left-1/2 top-1/2  -translate-x-1/2 -translate-y-1/2 w-full h-full'>
        <img className='w-full h-full' src={bgGradient} alt='bg' />
      </div>
      <div
        style={{
          animationDelay: '60ms',
          animationDuration: '200ms'
        }}
        // className="flex justify-center opacity-0 items-center h-screen bg-sidebar bg-opacity-80 inset-0"
      >
        <TextLoop className=' text-[17px] font-medium absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>
          {loopTexts.map((text, index) => (
            <span className='' key={index}>
              {text}
            </span>
          ))}
        </TextLoop>
        <Animation />
      </div>
    </div>
  );
}
